import { axiosInstanceSaviPinOprf, getAxiosOptions } from 'services/APIService';

interface PepperResponse {
  blinded_pepper: string;
}

interface OprfPublicKeyResponse {
  public_key: string;
}

/** base64-encoded VOPRF public key for one identity (each identity has its own OPRF key). */
export const getOprfPublicKey = async (userId: string): Promise<string> => {
  const { data } = await axiosInstanceSaviPinOprf.get<OprfPublicKeyResponse>('/pin/public-key', {
    ...getAxiosOptions(),
    params: { user_id: userId },
  });
  return data.public_key;
};

/** Sends a blinded VOPRF evaluation request; `blinded` and the response are both base64. */
export const requestBlindedPepper = async (userId: string, blinded: string): Promise<string> => {
  const { data } = await axiosInstanceSaviPinOprf.post<PepperResponse>(
    '/pin/pepper',
    { user_id: userId, blinded },
    getAxiosOptions(),
  );
  return data.blinded_pepper;
};
